import Vue from "vue";
import VueRouter from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import Login from "@/pages/UserProfile/Login";
import Verif from "@/pages/UserProfile/verification";
// import Register from "@/pages/UserProfile/Register";
import Add from "@/pages/Add";
import Infos from "@/pages/Nodeinfos";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/maps",
    children: [
      {
        path: "dashboard",
        name: "Sensors Data Information",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          title: "Dash",
        },
      },
      {
        path: "add",
        name: "Add New Node",
        component: Add,
        meta: {
          requiresAuth: true,
          title: "Dash",
        },
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile,
        meta: {
          requiresAuth: true,
          title: "Dash",
        },
      },
      {
        path: "table",
        name: "Nodes Table",
        component: TableList,
        meta: {
          requiresAuth: true,
          title: "Dash",
        },
      },
      {
        path: "maps",
        name: "Nodes Maps",
        meta: {
          hideFooter: true,
          requiresAuth: true,
          title: "Dash",
        },
        component: Maps,
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
      },
      {
        path: "infos",
        name: "Node infos",
        component: Infos,
        meta: {
          requiresAuth: true,
          title: "Dash",
        },
      },
    ],
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      localStorage.getItem("authToken") === null ||
      localStorage.getItem("authToken") === undefined
    ) {
      next({
        path: "/",
      });
    } else next();
  } else next();
});

export default router;
